import { Link } from "react-router-dom";
import { movies, tvShows } from "@/lib/media";
import { newsList } from "@/mocks/news";

const shortcuts = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "欧美大片 · 日韩佳片",
    count: movies.length,
    tone: "primary" as const,
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "热播剧集 · 连载完结",
    count: tvShows.length,
    tone: "accent" as const,
  },
  {
    to: "/category/news",
    icon: "ri-newspaper-line",
    title: "影视资讯",
    desc: "行业动态 · 快讯报道",
    count: newsList.length,
    tone: "secondary" as const,
  },
];

const toneClasses = {
  primary: {
    box: "bg-primary-50 border-primary-100 hover:border-primary-300",
    icon: "bg-primary-500 text-background-50",
    title: "text-foreground-950",
    count: "text-primary-600",
  },
  accent: {
    box: "bg-accent-50 border-accent-100 hover:border-accent-300",
    icon: "bg-accent-500 text-background-50",
    title: "text-foreground-950",
    count: "text-accent-600",
  },
  secondary: {
    box: "bg-secondary-50 border-secondary-100 hover:border-secondary-300",
    icon: "bg-secondary-500 text-background-50",
    title: "text-foreground-950",
    count: "text-secondary-600",
  },
};

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 md:px-8 -mt-10 md:-mt-14 relative z-10">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        {shortcuts.map((s) => {
          const t = toneClasses[s.tone];
          return (
            <Link
              key={s.to}
              to={s.to}
              className={`group flex items-center gap-4 p-4 md:p-5 rounded-lg border bg-background-50 transition-all card-hover ${t.box}`}
            >
              <span className={`w-12 h-12 md:w-14 md:h-14 rounded-md flex items-center justify-center shrink-0 ${t.icon}`}>
                <i className={`${s.icon} text-2xl`} />
              </span>
              <div className="min-w-0 flex-1">
                <h3 className={`font-bold text-base md:text-lg font-heading ${t.title}`}>
                  {s.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-0.5 truncate">
                  {s.desc}
                </p>
              </div>
              <div className="text-right shrink-0">
                <div className={`text-xl md:text-2xl font-extrabold font-heading ${t.count}`}>
                  {s.count}
                </div>
                <div className="text-[11px] text-foreground-400">部内容</div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}